<template>
  <!-- Cards -->
  <div class="row">
    <div class="col-xl-3 col-lg-4 col-md-6 col-12 d-flex align-items-stretch p-2 partner-tile" v-for='partner in partners' :key='partner.id' :id="'partnerTile-' + partner.id">
        <div class="card w-100 partner-card" @click="emitOpenModal(partner.id, partner.name)">
          <div class="img-wrapper">
            <img class="card-img-top partner-logo" :src="partner.logo_url" :alt="partner.name + ' Logo'">
          </div>
          <span v-if="partner.badge" class="card-badge bg-secondary rounded-card-badge"><span>{{partner.badge}}</span></span>
          <div class="card-body d-flex flex-column">
            <h5 class="card-title">{{partner.name}}</h5>
            <hr class="card-hr">
            <p class="card-text">{{partner.tagline}}</p>
            <span class="badge bg-secondary" v-if="customers[partner.id]"> {{customers[partner.id]}}</span>
            <a v-if="!customers[partner.id]" href="#" class="btn btn-primary mt-auto learn-more">Learn more</a>
            <a v-else href="#" class="btn btn-primary mt-auto position-relative">
              <span v-if="customers[partner.id] && customers[partner.id].active" class="bg-secondary card-badge rounded-card-badge mt-auto green-badge">Active</span>
              Settings
            </a>
          </div>
        </div>
    </div>
  </div>
  <!-- Cards end -->
  <!-- Pagination
  <nav v-if="pagination" aria-label="...">
    <ul class="pagination justify-content-center">
      <li v-if="pagination.prev" class="page-item">
        <a class="page-link" @click="setPagination(apiStatus.currentPage - 1)">Previous</a>
      </li>
      <li v-if="pagination.prev" class="page-item" aria-current="page">
        <a class="page-link" @click="setPagination(apiStatus.currentPage - 1)">{{apiStatus.currentPage -1}}</a>
      </li>
      <li class="page-item active" aria-current="page">
        <a class="page-link">{{apiStatus.currentPage}}</a>
      </li>
      <li v-if="pagination.next" class="page-item" aria-current="page">
        <a class="page-link" @click="setPagination(apiStatus.currentPage + 1)">{{apiStatus.currentPage +1}}</a>
      </li>
      <li v-if="pagination.next" class="page-item">
        <a class="page-link" @click="setPagination(apiStatus.currentPage + 1)" href="#">Next</a>
      </li>
      <li v-if="pagination.last && (apiStatus.lastPage != apiStatus.currentPage)" class="page-item">
        <a class="page-link" @click="setPagination(apiStatus.lastPage)" href="#">Last</a>
      </li>
    </ul>
  </nav>
  Pagination end -->
</template>

<script>
export default {
  props: {
    partners: {
      type: Array,
      default: []
    },
    pagination: {
      type: Object,
      default: {}
    },
    customers: {
      type: Object,
      default: {}
    },
    apiStatus: {
      type: Object,
      default: {}
    }
  },
  emits: ['emitOpenModal', 'queryResults', 'apiStatus', 'trackAction'],
  setup(props, ctx) {
    const apiStatus = props.apiStatus
    const pagination = props.pagination

    async function emitOpenModal(partnerId, partnerName){
      ctx.emit('openModal', partnerId)
      ctx.emit('trackAction', '$click', { text: partnerName, type: 'partner-click'})
    }
    async function setPagination(page){
      apiStatus.currentPage = page
      ctx.emit('queryResults')
    }

    return {
      setPagination,
      emitOpenModal,
    }
  },
}
</script>
